import { useMemo } from 'react';
import { parseMinMaxDateTimeValue } from '../../../../utils/parseMinMaxDateTimeValue';

export const useMinMaxDateTimeValue = (
  min: string | undefined,
  max: string | undefined,
  timeOnly = false
): { minValue: Date | null; maxValue: Date | null } => {
  const minValue = useMemo(
    () => (min ? parseMinMaxDateTimeValue(min, timeOnly) : null),
    [min, timeOnly]
  );
  const maxValue = useMemo(
    () => (max ? parseMinMaxDateTimeValue(max, timeOnly) : null),
    [max, timeOnly]
  );
  return { minValue, maxValue };
};
